import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page97() {
  useEffect(() => {
    document.title = "Маяк — Страница 96"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page95" />
        <ForwardLink href="/page97" />
      </div>

      <p style={{ textAlign: "right" }}>96.</p>
      <p>ВНУТРИ. МАЯК. ПЕРЕХОД – НОЧЬ</p>
      <p>
        Ползком, дрожа и истекая кровью, МОЛОДОЙ медленно пробирается<br/>
        к башне...
      </p>
      <br/>
      <p>ВНУТРИ. МАЯК. ЛЕСТНИЦА БАШНИ – НЕСКОЛЬКО МГНОВЕНИЙ СПУСТЯ</p>
      <p>МОЛОДОЙ продолжает пробираться, медленно...</p>
      <br/>
      <p>ВНУТРИ. МАЯК. МАШИННОЕ ОТДЕЛЕНИЕ – НЕСКОЛЬКО МГНОВЕНИЙ СПУСТЯ</p>
      <p>
        МОЛОДОЙ медленно поднимается по лестнице и, используя КЛЮЧ, ОН ОТКРЫВАЕТ<br/>
        ЛЮК, ведущий в ФОНАРНОЕ ОТДЕЛЕНИЕ...
      </p>
      <p>Ослепительный СВЕТ кружится...</p>
      <p>МОЛОДОЙ загипнотизирован...</p>
      <br/>
      <p>ВНУТРИ. МАЯК. ФОНАРНОЕ ОТДЕЛЕНИЕ – НОЧЬ</p>
      <p>МОЛОДОЙ смотрит вперед...</p>
      <p>
        Вот они: ФРЕНЕЛЕВЫЕ ЛИНЗЫ. Это массивный, шести футов в высоту<br/>
        драгоценный камень неописуемой красоты, с восемью мерцающими медными<br/>
        ножками. Кажется, он поет...
      </p>
      <p>Он идет к нему...</p>
      <p>Как по волшебству, вращение ЛИНЗ начинает замедляться...</p>
      <p>ЛИНЗЫ <u>перестают</u> вращаться...</p>
      <p>Он восхищается этим.</p>
      <p>Медленно, дверцы линз раскрываются как крылья, навстречу ему...</p>
      <p>Свет становится все ярче...</p>
      <p>Пауза.</p>
      <p>Он привыкает к этому.</p>
      <p>Пауза.</p>
      <p>Слезы падают у него из глаз.</p>
      <p>Он улыбается.</p>
      <p>Медленно, он просовывает руку в свет...</p>
      <p style={{ textAlign: "right" }}>96.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page95" />
        <ForwardLink href="/page97" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710719202/the-lighthouse-script/zgj5bmvohtw6vh5pl3pp.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page97;
